import ProductDescription from './ProductDescription'

const BSWheatPastaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '009BS',
  IsBroadband: true,
  WholeWheatFlour: false,
  PastaShape: '',
  Size: '',
}

export default BSWheatPastaProduct
